import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ArrowUp, MessageCircle } from 'lucide-react';
import Navbar from './Navbar';
import Footer from './Footer';

const DEFAULT_CLINIC = {
  clinic_address: 'Saray Mh. Kıyıkent Sk. No:5, Alanya, Antalya',
  clinic_phone: '+90 533 678 84 90',
  clinic_whatsapp: '+90 533 678 84 90',
};

const PublicLayout = ({ children }) => {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const [clinic, setClinic] = useState(DEFAULT_CLINIC);

  const apiUrl = useMemo(
    () =>
      import.meta.env.VITE_API_URL ||
      (typeof window !== 'undefined' ? window.location.origin : ''),
    []
  );

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${apiUrl}/api/settings/public?group=contact`);
        if (!res.ok) return;
        const payload = await res.json();
        if (!cancelled && payload?.data) {
          setClinic((prev) => ({ ...prev, ...payload.data }));
        }
      } catch (_e) {
        // silent fallback
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [apiUrl]);

  const waNumber = String(clinic?.clinic_whatsapp || '').replace(/[^\d]/g, '');

  return (
    <div>
      <Navbar />

      {/* Spacer so content doesn't sit under fixed header on inner pages */}
      {!isHome && <div style={{ height: 88 }} aria-hidden />}

      <main>{children}</main>

      <Footer clinic={clinic} />

      {/* Floating actions */}
      {waNumber && (
        <a
          href={`https://wa.me/${waNumber}`}
          target="_blank"
          rel="noreferrer"
          className="whatsapp-float"
          aria-label="WhatsApp"
        >
          <MessageCircle size={24} />
        </a>
      )}
      <button
        className="scroll-top visible"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="Scroll to top"
      >
        <ArrowUp size={18} />
      </button>
    </div>
  );
};

export default PublicLayout;
